import React, { Suspense } from "react";
import { ProcessEditUser } from "@rankmi/ats-app";

const ProcessUser = ({
  selectionProcessId,
}) => {
  return (
    <Suspense fallback={<div>Loading...</div>}>    
      <ProcessEditUser
        selectionProcesId={selectionProcessId}
      />
    </Suspense>

  );
}

export default ProcessUser;